// FRAMEWORK
import React, { useEffect } from 'react'
import { Modal } from 'react-bootstrap'

// APP
import { ThemeProvider } from '@emotion/react'
import AppContext from '../context/app'
import Navbar from '../components/navbar'
import InMusic from '../components/inmusic'
import Footer from '../components/footer'
import SignupModal from '../components/signup-modal'
import EmailSignup from '../components/email-signup'
import Violator from '../components/violator'

// HOOKS
import useGetAppValue from '../hooks/useGetAppValue'
import useWindowEventListenersEffect from '../hooks/useWindowEventListenersEffect'
import useCountryEffect from '../hooks/useCountryEffect'
import useCartIdEffect from '../hooks/useCartIdEffect'

// CSS
import * as styles from '../styles/exports.module.scss'
import 'bootstrap/dist/css/bootstrap.min.css'
import '../styles/bootstrap-overrides.scss'
import '../styles/global.scss'

export default function MainLayout({ children }) {
    const value = useGetAppValue()
    const { globalModalChildren, setGlobalModalChildren } = value

    useWindowEventListenersEffect(value)
    useCountryEffect(value)
    useCartIdEffect(value)

    // https://emotion.sh/docs/theming
    const theme = {
        fonts: {
            primary: styles.primaryFont,
            secondary: styles.secondaryFont,
        },
        colors: {
            primary: styles.primaryColor,
            gray: styles.gray,
            light: styles.light,
            dark: styles.dark,
        },
    }
    
    // FOR DEBUGGING
    // useEffect(() => {
    //     console.log(value)
    // }, [value])

    return (
        <AppContext.Provider value={value}>
            <ThemeProvider theme={theme}>
                <SignupModal />
                <Violator />

                {/* z-index of navbar should be less than <main> if a modal is open */}
                <Navbar style={{ zIndex: value.isModalOpen ? 2 : 3 }} />
                
                <main
                    className='position-relative'
                    style={{ zIndex: value.isModalOpen ? 3 : 2 }}
                >
                    {children}
                </main>

                <footer
                    className='position-relative'
                    style={{ zIndex: 1 }}
                >
                    <EmailSignup />
                    <InMusic />
                    <Footer />
                </footer>

                <Modal
                    size='xl'
                    centered
                    show={globalModalChildren ? true : false}
                    onHide={() => setGlobalModalChildren(undefined)}
                    css={{ '& .modal-content': { background: 0 }}}
                >
                    {globalModalChildren}
                </Modal>
            </ThemeProvider>
        </AppContext.Provider>
    )
}